import {months} from '../../../common/constants/months';

export const getYears = (type, lastYearWithData, initialYearSelected) => {
  const years = [];
  const initialYear = 2014;
  const numberOfYears = lastYearWithData - initialYear;
  for (let i = 0; i <= numberOfYears; i++) {
    years.push(initialYear + i);
  }

  return Object.keys(years).map((position) => {
    const year = years[position];
    const finalYearDisabled =
      type === 'final' && year < initialYearSelected;
    return {'text': year, 'value': year, 'disabled': finalYearDisabled};
  });
};

export const getMonths = ({
  lastYearWithData,
  lastMonthWithData,
  initialYearSelected,
}) => {
  return Object.keys(months).map((month) => {
    const isMonthDisabled =
      lastYearWithData === initialYearSelected &&
      months[month] > lastMonthWithData;
    return {'text': month, 'value': months[month], 'disabled': isMonthDisabled};
  });
};

export const getAllOptionsMonths = ({
  lastYearWithData,
  lastMonthWithData,
  initialYearSelected,
}) => {
  const months = getMonths({
    lastYearWithData,
    lastMonthWithData,
    initialYearSelected,
  });
  months.push({'text': 'Todos', 'value': 'ALL', 'disabled': false});
  return months;
};

